class BlogGridFilter extends HTMLElement {
    constructor() {
        super();

        this.wrap = this.querySelector(".section-main-blog-filter-grid");
        this.filterButtons = this.querySelectorAll(".blog-filter-btn");

        if (!this.wrap) return;

        this.blogUrl = this.dataset.blogUrl;
        this.sectionId = this.dataset.sectionId;

        this.currentTagUrl = this.blogUrl;
        this.isLoading = false;

        this.init();
    }

    init() {
        this.bindEvents();
        this.bindFilterScroll();
    }

    // Lets a normal mouse (wheel scrolls vertically, no shift key) move the
    // tag filter row horizontally, plus click-and-drag scrolling.
    bindFilterScroll() {
        const track = this.querySelector(".blog-filter");
        if (!track) return;

        track.addEventListener(
            "wheel",
            (e) => {
                if (track.scrollWidth <= track.clientWidth) return;
                // If the input is already mostly horizontal (trackpad/shift-wheel), leave it alone.
                if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
                e.preventDefault();
                track.scrollLeft += e.deltaY;
            },
            { passive: false }
        );

        let isDown = false;
        let dragged = false;
        let startX = 0;
        let startScrollLeft = 0;

        track.addEventListener("mousedown", (e) => {
            isDown = true;
            dragged = false;
            startX = e.pageX;
            startScrollLeft = track.scrollLeft;
            track.classList.add("dragging");
        });

        window.addEventListener("mousemove", (e) => {
            if (!isDown) return;
            const delta = e.pageX - startX;
            if (Math.abs(delta) > 5) dragged = true;
            if (dragged) {
                e.preventDefault();
                track.scrollLeft = startScrollLeft - delta;
            }
        });

        window.addEventListener("mouseup", () => {
            isDown = false;
            track.classList.remove("dragging");
        });

        // Swallow the click that follows a drag so a filter button doesn't
        // fire when the user was just dragging the row.
        track.addEventListener(
            "click",
            (e) => {
                if (dragged) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    dragged = false;
                }
            },
            true
        );
    }

    bindEvents() {
        this.filterButtons.forEach((button) => {
            button.addEventListener("click", () => this.handleFilterClick(button));
        });
    }

    // --- Tag filter: always re-fetches page 1 from the server, using the
    //     button's real Shopify tag URL (e.g. /blogs/news/tagged/recipes) ---
    handleFilterClick(button) {
        if (this.isLoading) return;

        this.filterButtons.forEach((btn) => btn.classList.remove("active"));
        button.classList.add("active");

        this.currentTagUrl = button.dataset.url || this.blogUrl;

        this.fetchAndRender(this.decorateUrl(this.currentTagUrl));
    }

    // Ensures section_id is present so Shopify returns only this section's markup.
    decorateUrl(rawUrl) {
        const url = new URL(rawUrl, window.location.origin);
        url.searchParams.set("section_id", this.sectionId);
        return url.toString();
    }

    async fetchAndRender(url) {
        this.isLoading = true;
        this.classList.add("loading");

        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error(`Request failed: ${response.status}`);

            const html = await response.text();
            const doc = new DOMParser().parseFromString(html, "text/html");

            const newWrap = doc.getElementById(`BlogGridWrap-${this.sectionId}`);

            if (newWrap) {
                this.wrap.innerHTML = newWrap.innerHTML;
            }

            history.replaceState({}, "", this.currentTagUrl);
        } catch (err) {
            console.error("Blog grid fetch failed:", err);
        } finally {
            this.isLoading = false;
            this.classList.remove("loading");
        }
    }
}

customElements.define("blog-grid-filter", BlogGridFilter);